export const MINI_BASKET_CONSTANTS = {
    TITLE: 'Basket',
    EMPTY_MESSAGE: 'Your basket is empty',
};
